// export const isLocal = process.env['REACT_APP_STAGE'] === 'local';
export const isLocal = false;
// console.log(process.env)
export const LOGIN_URL = isLocal? "http://localhost:3000":"https://www.warehouse.watkinscorner.net"
export const LOGOUT_URL = isLocal? "http://localhost:3000":"https://www.warehouse.watkinscorner.net"
export const COGNITO_AUTHORITY = "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_heF712mLN"
export const COGNITO_DOMAIN = "https://us-east-1hef712mln.auth.us-east-1.amazoncognito.com";
export const COGNITO_CLIENT_ID = "17f83js3crn061vhb7moroaudk"
export const API_URL = ""//"https://api.warehouse.watkinscorner.net"